import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { LEGAL } from "@/constants/legal";

export default function NoteLegali() {
  return (
    <LegalLayout overline="Imprint" title="Note Legali">
      <p className="lead">
        Informazioni rese ai sensi dell'art. 7 del D.Lgs. 70/2003 in materia di
        commercio elettronico e dell'art. 3 del Codice di Deontologia
        Professionale.
      </p>

      <h2>Titolare del sito e responsabile dei contenuti</h2>
      <p>
        <strong>{LEGAL.ownerName}</strong>
        <br />
        Sede: {LEGAL.address}
        <br />
        Codice Fiscale: {LEGAL.fiscalCode}
      </p>

      <h2>Contatti</h2>
      <p>
        Email: <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>
        <br />
        WhatsApp: <a href={`https://wa.me/${LEGAL.whatsappWa}`} target="_blank" rel="noopener noreferrer">{LEGAL.whatsapp}</a>
        <br />
        Sito web: <a href={LEGAL.siteUrl}>{LEGAL.siteUrl}</a>
      </p>

      <h2>Qualifica professionale</h2>
      <p>
        Michele Roccaro esercita l'attività di Consulente ed Educatore Digitale
        Tecnologico e di Sostenibilità ai sensi della{" "}
        <strong>{LEGAL.acdtLaw}</strong> "Disposizioni in materia di professioni
        non organizzate", tramite l'associazione professionale{" "}
        <strong>A.C.D.T.</strong> (Associazione Consulenti Digitali e
        Tecnologi), con sede in {LEGAL.acdtAddress}.
      </p>
      <p>
        L'iscrizione all'associazione e il rispetto del relativo codice
        deontologico garantiscono l'utente sotto il profilo della qualità della
        prestazione resa.
      </p>

      <h2>Hosting del sito</h2>
      <p>
        Il sito è ospitato su infrastruttura cloud Emergent. Per informazioni
        sull'infrastruttura consulta{" "}
        <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer">emergent.sh</a>.
      </p>

      <h2>Marchi e proprietà intellettuale</h2>
      <p>
        Il nome <em>"Metodo di Mare"</em>, il logo, i contenuti del libro,
        dell'audiolibro e del sito sono di proprietà di {LEGAL.ownerName} e
        protetti dalla L. 633/1941 sul diritto d'autore. Tutti i marchi
        appartengono ai rispettivi titolari.
      </p>

      <h2>Limitazione di responsabilità</h2>
      <p>
        I contenuti del sito hanno finalità informativa, formativa e
        divulgativa. Pur garantendo il massimo impegno nell'accuratezza dei
        contenuti, il Titolare non assume alcuna responsabilità per eventuali
        errori o omissioni, né per i risultati derivanti dall'applicazione dei
        contenuti, che restano a esclusivo rischio dell'utente.
      </p>

      <h2>Risoluzione controversie</h2>
      <p>
        Per le controversie relative ai contratti di vendita conclusi sul sito
        si rimanda ai{" "}
        <a href="/termini">Termini di Vendita</a> e alla piattaforma ODR
        europea (
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
        >
          ec.europa.eu/consumers/odr
        </a>
        ).
      </p>

      <h2>Foro competente</h2>
      <p>
        Per qualsiasi controversia non riconducibile al rapporto B2C è
        competente in via esclusiva il Foro di Ragusa.
      </p>

      <p className="mt-12 text-sm text-[#3A4F6B]">
        Ultimo aggiornamento: {LEGAL.lastUpdated}.
      </p>
    </LegalLayout>
  );
}
